





































































import { Popup, Button, Radio } from '@hb/coffee';
import {
  defineComponent, computed, onMounted,
  PropType, ref,
} from '@vue/composition-api';
import {
  SuperCardSummaryBackType,
} from '@/api/rights/types';
import { ubtSetupPageButton, ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import {
  financeLoanPackageEntryRetainPopupExpose,
  financeLoanPackageEntryRetainPopupAgreementCheck,
  financeLoanPackageEntryRetainPopupBottomButton,
  financeLoanPackageEntryRetainPopupAgreement,
} from './tianqi';


export default defineComponent({
  name: 'PopStyleB',
  components: {
    Popup,
    Button,
    Radio,
  },
  props: {
    superMemberInfo: {
      type: Object as PropType<SuperCardSummaryBackType>,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    /** 协议预览,注入方法，兼容js调用的场景 */
    contractPreview: {
      type: Function as PropType<() => void>,
      default: () => {},
    },
    tqParams: {
      type: Object as PropType<Dictionary>,
      default: () => ({}),
    },
  },
  emits: ['goDetail', 'update:modelValue', 'choose', 'previewContract'],
  setup(props: {
      modelValue: boolean;
      superMemberInfo: SuperCardSummaryBackType;
      contractPreview: () => void;
      tqParams: Dictionary;
    }, { emit }: {
      emit: (event: string, ...args: unknown[]) => void;
    }) {
    /** 是否展示popup */
    const showPopup = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    /** 协议是否勾选 */
    const checked = ref(false);

    /** 未勾选协议时 需要展示气泡 是否展示提示 */
    const showTips = ref(false);

    const toggleSelect = () => {
      // 切换勾选状态
      checked.value = !checked.value;

      if (checked.value) {
        // 切换勾选协议埋点
        ubtSetupPageButton(financeLoanPackageEntryRetainPopupAgreementCheck, {
          ...props.tqParams,
          checked: checked.value,
        });
      }

      // 如果勾选了协议，并且此时气泡打开 则隐藏气泡
      if (checked.value && showTips.value) {
        showTips.value = false;
      }
    };

    /** 协议预览 */
    const previewContract = async () => {
      // 点击预览协议埋点
      ubtSetupPageButton(financeLoanPackageEntryRetainPopupAgreement, {
        ...props.tqParams,
      });
      if (props.contractPreview) {
        props.contractPreview();
      }
      emit('previewContract');
    };

    /** 点击确定 */
    const handleConfirm = () => {
      // 点击同意协议并提交埋点
      ubtSetupPageButton(financeLoanPackageEntryRetainPopupBottomButton, {
        ...props.tqParams,
        buttonName: '同意协议并提交',
        checked: checked.value,
      });
      if (!checked.value) {
        showTips.value = true;
        return;
      }
      emit('submit', true);
    };

    /** 点击放弃 */
    const handleReject = () => {
      // 点击放弃特权埋点
      ubtSetupPageButton(financeLoanPackageEntryRetainPopupBottomButton, {
        ...props.tqParams,
        buttonName: '放弃优惠',
      });
      emit('submit', false);
    };

    onMounted(() => {
      // 曝光埋点
      ubtSetupModuleExpose(financeLoanPackageEntryRetainPopupExpose, props.tqParams);
    });

    return {
      showPopup,
      previewContract,
      handleConfirm,
      handleReject,
      checked,
      toggleSelect,
      showTips,
    };
  },
});
